var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashflowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 4.99984H24.7C24 3.0665 22.1667 1.6665 20 1.6665C17.8333 1.6665 16 3.0665 15.3 4.99984H8.33333C6.5 4.99984 5 6.49984 5 8.33317V31.6665C5 32.5506 5.35119 33.3984 5.97631 34.0235C6.60143 34.6487 7.44928 34.9998 8.33333 34.9998H31.6667C33.5167 34.9998 35 33.5165 35 31.6665V8.33317C35 7.44912 34.6488 6.60127 34.0237 5.97615C33.3986 5.35103 32.5507 4.99984 31.6667 4.99984ZM20 4.99984C20.9167 4.99984 21.6667 5.74984 21.6667 6.6665C21.6667 7.58317 20.9167 8.33317 20 8.33317C19.0833 8.33317 18.3333 7.58317 18.3333 6.6665C18.3333 5.74984 19.0833 4.99984 20 4.99984ZM11.6667 11.6665H28.3333V8.33317H31.6667V31.6665H8.33333V8.33317H11.6667V11.6665ZM16.6667 26.6665H13.3333V18.3332H10L15 13.3332L20 18.3332H16.6667V26.6665ZM23.3333 16.6665H26.6667V24.9998H30L25 29.9998L20 24.9998H23.3333V16.6665Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashflowsIcon);
export default __webpack_public_path__ + "static/media/cashflows_icon.66c017d7fe4d42fa04b49c1f33493b49.svg";
export { ForwardRef as ReactComponent };